import Axios from 'axios';
import * as TokenHelpers from '../utils/tokenHelpers';
import * as ApiHelper from '../utils/apiHelper';

export function validateCoupon(coupon) {

    let path = ApiHelper.API_ROOT+'/discounts/' + coupon;
    return new Promise((resolve, reject) => {
      let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
      Axios({
        url: path,
        method: 'get',
        headers: headers
      })
      .then(function(response) {
        console.log("Discount Response", response.data);
        resolve(response.data);
      }).catch(ApiHelper.handleUserAuth).catch(function(error) {
        console.log("Discount Error", error.response);
        reject({error: error.response.data})
      });
    });
  }


// WEBPACK FOOTER //
// ./src/services/discounts.js